import {
  HowToSaveType,
  howToSaveInvestmentProducts,
} from 'components/features/target-achievement-support/utils/type';
import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';

export const AdviceNotAchievedModal = ({
  hide,
  isShow,
  type,
  goPortfolioAnalysis,
}: {
  isShow: boolean;
  hide: () => void;
  type: HowToSaveType;
  goPortfolioAnalysis: () => void;
}): React.ReactElement => {
  const next = () => {
    hide();
    goPortfolioAnalysis();
  };

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="flex flex-row justify-center mt-2">
            <img
              alt="タイトル"
              src="/static/images/advisor/unachieved_alert.svg"
            />
          </div>
          <div className="flex flex-row mt-4 items-center">
            <div className="icon-advice-avatar-top">
              <img
                alt=""
                className="rounded-full flex-grow"
                src="/static/images/advisor/ai_img_3.svg"
              />
            </div>
            <div className="ml-2 text-sm">
              目標の達成が難しいと感じたとき、見直しのポイントをお知らせします。
            </div>
          </div>
          <div className="p-2 mt-2 border border-bluegray-300 rounded">
            <div className="text-base font-bold text-teal-700">
              1. 家計の見直し
            </div>
            <div className="text-base text-bluegray-700">
              削減しやすい「固定費」から見直して積立に回すお金を増やす
            </div>
          </div>
          <div className="p-2 mt-2 border border-bluegray-300 rounded text-bluegray-700">
            <div className="text-base font-bold text-teal-700">
              2. 目標金額・期間の見直し
            </div>
            <div className="text-base text-bluegray-700">
              無理のない目標金額・目標期間に再設定
            </div>
          </div>
          {type === howToSaveInvestmentProducts && (
            <div className="p-2 mt-2 border border-bluegray-300 rounded text-bluegray-700">
              <div className="text-base font-bold text-teal-700">
                3. 資産配分(ポートフォリオ)の見直し
              </div>
              <div className="text-sm text-bluegray-700">
                リスクを抑えた運用方法の提案をチェック！
              </div>
              <div className="text-xs text-bluegray-700">
                ※目標利回りが高いと提案できない事があります
              </div>
              <div className="flex flex-col">
                <button
                  className="rounded-lg border border-blue-700 bg-gray-50 text-blue-700 mt-4 p-2"
                  onClick={next}>
                  <div className="font-bold text-sm">
                    ポートフォリオの提案を見てみる
                  </div>
                </button>
              </div>
            </div>
          )}
          <div className="m-4 flex flex-col">
            <button
              className="text-sm text-bluegray-500 py-2 flex flex-row items-center justify-center mt-2"
              onClick={hide}>
              閉じる
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};
